$(document).ready ->
  activities = $('.activities-background-swap')
  activity = $('.activity')
  current = '.current'

  activity.on
    mouseenter: ->
      bg = $(this).data 'activity-bg'
      $(this).parent().addClass bg
    mouseleave: ->
      bg = $(this).data 'activity-bg'
      $(this).parent().removeClass bg
